module.exports = __webpack_public_path__ + "static/img/wealth_level_82.0d20203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_82.png
// module id = lo30
// module chunks = 0